import { useCallback, useMemo } from "react"


const useHeaderBtns = () => {

    const addNewUser = useCallback(() => {

    }, [])

    const headerBtns = useMemo(() => [
        {
            label: "הוספת איש צוות",
            action: addNewUser
        }
    ], [])

    return headerBtns
}

export default useHeaderBtns